import React from 'react';
import Icon from "../";
export default function IconSpotifyLogo(props) {
  return React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<path d=\"M18.51 10.85a.87.87 0 01-.39-.09 17 17 0 00-11.88-1.2.87.87 0 01-.45-1.68A18.69 18.69 0 0118.9 9.2a.87.87 0 01-.39 1.65zm-.43 2.53a.87.87 0 01-1.17.37 13.71 13.71 0 00-10.09-1 .87.87 0 01-.48-1.67 15.45 15.45 0 0111.37 1.14.87.87 0 01.37 1.16zm-1.2 3a.87.87 0 01-1.18.33 10.47 10.47 0 00-8.28-.84.87.87 0 01-.53-1.66 12.22 12.22 0 019.66 1 .87.87 0 01.33 1.21zM12 2a10 10 0 1010 10A10 10 0 0012 2z\" fill=\"#181818\"/>"
    }
  }));
}